/* Empty search recovery. Globo continues to own queries, results and prices. */
(() => {
  'use strict';
  if (window.__collinoSearchRecovery) return;
  window.__collinoSearchRecovery = true;
  let frame = 0;
  const sync = () => {
    frame = 0;
    const template = document.getElementById('collino-search-recovery-template');
    if (!template) return;
    document.querySelectorAll('.glFilter-search-popup').forEach(popup => {
      const message = popup.querySelector('.gl-fullscreen-suggestions');
      const empty = message && /(?:no (?:results|products|matches)|(?:couldn.t|cannot|can.t) find|nothing found|sorry)/i.test(message.textContent)
        && !popup.querySelector('.gl-product-card, .gl-list__item a[href*="/products/"]');
      const existing = popup.querySelector('[data-search-recovery]');
      if (!empty) { existing?.remove(); return; }
      if (!existing) message.after(template.content.cloneNode(true));
      popup.querySelectorAll('[data-search-recovery] a').forEach(link => {
        if (link.getAttribute('role') !== 'link') link.setAttribute('role', 'link');
        if (link.tabIndex !== 0) link.tabIndex = 0;
      });
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const init = () => {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', event => {
      if (!event.target.closest?.('[data-search-retry]')) return;
      const popup = event.target.closest('.glFilter-search-popup');
      const input = popup?.querySelector('#gl-d-searchbox-input') || document.getElementById('header-search-input');
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new KeyboardEvent('keyup', { key: 'Backspace', bubbles: true }));
      input.focus();
    });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
